import { CampaignData } from '../pages/admin/campaign-configuration';
import { Status } from '../ui/components';

const defaultCurrentDate = new Date();
const defaultEndDate = new Date(defaultCurrentDate.getTime());
defaultEndDate.setDate(defaultCurrentDate.getDate() + 10);
const dataRemovalDate = new Date(defaultEndDate.getTime());
dataRemovalDate.setDate(dataRemovalDate.getDate() + 180);

const initialCampaignData: CampaignData = {
  campaignId: '',
  campaignName: '',
  campaignDescription: '',
  campaignTextLinkDisplay: 0,
  campaignTextLink: '',
  campaignStart: defaultCurrentDate.toString(),
  campaignEnd: defaultEndDate.toString(),
  dataRemovalDate: dataRemovalDate.toString(),
  loginId: 'admin',
  campaignStatus: 'NEW',
  campaignType: 'CHALLENGE',
  gameType: 'SCRATCH AND WIN',
  isChallenge: 0,
  promoChallengeId: '',
  redemptionCriteria: '',
  activities: {
    participant: {
      name: '',
      description: '',
      status: Status.INACTIVE,
      teamSize: 0,
      enrollmentType: 'PARTICIPANT',
      validity: {
        type: 'DAYS',
        value: 0,
        bufferDays: 15,
        bufferMonths: 0,
      },
      pin: [],
      rules: [
        {
          actionType: 'WEIGHT_IN',
          kpiCode: 'WEIGHT_IN_TEAM',
          description: '',
          calculationType: 'ONETIME',
          targetFrom: '3',
          targetTo: '0',
          point: '',
          fullfillmentType: null,
          reward: '',
          subKpiCode: [],
        },
        {
          actionType: 'WEIGHT_IN',
          kpiCode: 'NEW_ABO_TEAM',
          description: '',
          calculationType: 'ONETIME',
          targetFrom: '1',
          targetTo: '0',
          point: '',
          fullfillmentType: null,
          reward: '',
          subKpiCode: [],
        },
        {
          actionType: 'WEIGHT_OUT',
          kpiCode: 'WEIGHT_OUT_TEAM',
          description: '',
          calculationType: 'ONETIME',
          targetFrom: '3',
          targetTo: '0',
          point: '',
          fullfillmentType: null,
          reward: '',
          subKpiCode: [],
        },
        {
          actionType: 'WEIGHT_OUT',
          kpiCode: 'WEIGHT_ACHIEVEMENT_TEAM',
          description: '',
          calculationType: 'ONETIME',
          targetFrom: '0',
          targetTo: '0',
          fullfillmentType: 'EITHER',
          point: '',
          reward: '',
          voucher: '',
          subKpiCode: [
            {
              subKpiCode: 'WEIGHT_LOST',
              points: '0',
              targetFrom: '0',
              targetTo: '0',
            },
            {
              subKpiCode: 'BODY_FAT_LOST',
              points: '0',
              targetFrom: '0',
              targetTo: '0',
            },
            {
              subKpiCode: 'MUSCLE_MASS_GAIN',
              points: '0',
              targetFrom: '0',
              targetTo: '0',
            },
          ],
        },
        {
          actionType: 'WEIGHT_OUT',
          kpiCode: 'WEIGHT_ACHIEVEMENT_INDIVIDUAL',
          description: '',
          calculationType: 'POINT',
          targetFrom: '0',
          targetTo: '0',
          fullfillmentType: 'EITHER',
          point: '1',
          reward: '',
          voucher: '',
          subKpiCode: [
            {
              subKpiCode: 'WEIGHT_LOST',
              points: '0',
              targetFrom: '0',
              targetTo: '0',
            },
            {
              subKpiCode: 'BODY_FAT_LOST',
              points: '0',
              targetFrom: '0',
              targetTo: '0',
            },
            {
              subKpiCode: 'MUSCLE_MASS_GAIN',
              points: '0',
              targetFrom: '0',
              targetTo: '0',
            },
          ],
        },
      ],
    },
    coach: {
      name: '',
      status: Status.INACTIVE,
      description: '',
      teamSize: 0,
      enrollmentType: 'COACH',
      validity: {
        type: 'MONTHS',
        value: 0,
        bufferDays: 15,
        bufferMonths: 2,
      },
      pin: [],
      rules: [
        {
          actionType: 'COACH_PROCESS_COUNT',
          kpiCode: 'NEW_ABO_COUNT',
          description: '',
          calculationType: 'COUNT',
          targetFrom: '0',
          targetTo: '0',
          fullfillmentType: null,
          point: '',
          reward: 'TRIP1',
          subKpiCode: [],
        },
        {
          actionType: 'COACH_PROCESS_POINT',
          kpiCode: 'COMPLETED_COUNT',
          description: '',
          calculationType: 'COUNT',
          targetFrom: '0',
          targetTo: '0',
          fullfillmentType: null,
          point: '',
          reward: '',
          subKpiCode: [],
        },
        {
          actionType: 'COACH_PROCESS_POINT',
          kpiCode: 'ACHIEVED_COUNT',
          description: '',
          calculationType: 'COUNT',
          targetFrom: '0',
          targetTo: '0',
          fullfillmentType: null,
          point: '',
          reward: '',
          subKpiCode: [],
        },
        {
          actionType: 'COACH_PROCESS_POINT',
          kpiCode: 'ALP_COUNT',
          description: '',
          calculationType: 'COUNT',
          targetFrom: '0',
          targetTo: '0',
          fullfillmentType: null,
          point: '',
          reward: '',
          subKpiCode: [],
        },
      ],
    },
    leader: {
      name: '',
      description: '',
      status: Status.INACTIVE,
      teamSize: 0,
      enrollmentType: 'LEADER',
      validity: {
        type: 'MONTHS',
        value: 0,
        bufferDays: 15,
        bufferMonths: 0,
      },
      pin: [],
      rules: [
        {
          actionType: 'LEADER_PROCESS',
          kpiCode: 'QUALIFIED_COACH',
          calculationType: 'COUNT',
          description: '',
          targetFrom: '0',
          targetTo: '0',
          fullfillmentType: null,
          point: '',
          reward: 'TRIP2',
          subKpiCode: [],
        },
      ],
    },
    order: {
      maxOrderNumber: 0,
      orderPeriod: 0,
      rules: [
        {
          type: 'amount',
          operator: '>',
          value: {
            amount: 0,
            currency: 'SGD',
          },
          combine: 'and',
        },
        {
          type: 'bundle',
          operator: 'in',
          value: [],
          combine: 'AND',
        },
        {
          type: 'item',
          operator: 'and',
          value: {
            base: [],
            addOn: [],
          },
          combine: 'or',
        },
      ],
      combineRules: 'and',
    },
  },
};

export { initialCampaignData };
